import React from 'react';
import Ingredient from '../Ingredient/Ingredient';

let Burger=props=>{
    let ingredientArr=props.ingredient.map(item=>
        {
            let amountArr=[...Array(item.amount).keys()];
            return amountArr.map(_ =>{
                return <Ingredient type={item.type} key={Math.random()}/>
            })
        })
        .reduce((arr,element)=>{
            return arr.concat(element)
        },[]);

        if (ingredientArr.length===0){
            ingredientArr=<p>Please add ingredient.</p>
        }

    return(
        <div>
            <center>
            <Ingredient type="top" />
            {ingredientArr}
            <Ingredient type="bottom" />
            </center>
            
        </div>
    )
}
export default Burger;